<template>
  <v-simple-table dense>
    <caption>
      <small>
        * Solo se listarán los detalles de la solicitud que se encuentren en estado
        <strong style="color: #4caf50">Aprobado</strong>
      </small>
    </caption>
    <thead>
      <tr>
        <th class="px-2 caption">#</th>
        <th class="px-2 caption" v-if="esTipoGastos">Sede Origen</th>
        <th class="px-2 caption">Banco Origen</th>
        <th class="px-2 caption">Cuenta Origen</th>
        <th class="px-2 caption">Sede Destino</th>
        <th class="px-2 caption">Banco Destino</th>
        <th class="px-2 caption">Cuenta Destino</th>
        <th class="px-2 caption">Detalle</th>
        <th class="px-2 caption">Cuenta</th>
        <th class="px-2 caption">Contable</th>
        <th class="px-2 caption">Estado</th>
        <th class="px-2 caption">Importe</th>
        <th class="px-2 caption">Seleccionar</th>
        <th class="px-2 caption">Tipo Desembolso</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td class="px-2 caption" colspan="11"></td>
        <td class="px-2 caption">
          <v-checkbox
            :value="estanMarcadosTodos"
            :indeterminate="checkboxEsIndeterminado"
            label="Todos"
            @click="marcarDesmarcarTodos"></v-checkbox>
        </td>
        <td class="px-2 caption">
          <v-select
            label="Para todos"
            v-model="tipoDesembolsoParaTodos"
            :items="[{ text: 'Ninguno', value: null }, ...tipoDesembolsos]"
            :disabled="detallesSolicitudesSeleccionados.length === 0"
            outlined
            dense
            hide-details
            placeholder="Seleccione uno"
            @input="cambiarTipoDesembolsoParaTodos" />
        </td>
      </tr>

      <tr v-for="(detalle, index) in detallesSolicitud" :key="detalle.id">
        <td class="px-2 caption">{{ index + 1 }}</td>
        <td class="px-2 caption" v-if="esTipoGastos">{{ detalle.sede_origen }}</td>
        <td class="px-2 caption">{{ detalle.banco_origen }}</td>
        <td class="px-2 caption">{{ detalle.cuenta_origen }}</td>
        <td class="px-2 caption">{{ detalle.sede_destino }}</td>
        <td class="px-2 caption">{{ detalle.banco_destino }}</td>
        <td class="px-2 caption">{{ detalle.cuenta_destino }}</td>
        <td class="px-2 caption">{{ detalle.detalle }}</td>
        <td class="px-2 caption">{{ `${detalle.clasificador.codigo} - ${detalle.clasificador.nombre}` }}</td>
        <td class="px-2 caption">
          {{
            detalle.clasificador.cuenta_contable
              ? `${detalle.clasificador.cuenta_contable.codigo} - ${detalle.clasificador.cuenta_contable.nombre}`
              : '-'
          }}
        </td>
        <td class="px-2 caption" style="color: #4caf50">
          {{ detalle.estado }}
        </td>
        <td class="px-2 caption text-right">{{ formatearValorAMoneda(detalle.importe) }}</td>
        <td class="px-2 caption">
          <v-checkbox v-model="detallesSolicitudesSeleccionados" label="Desembolsar" :value="detalle.id"></v-checkbox>
        </td>
        <td class="px-2 caption" style="width: 200px">
          <v-select
            v-model="detalle.tipo_desembolso"
            :items="tipoDesembolsos"
            outlined
            dense
            hide-details
            :disabled="!detallesSolicitudesSeleccionados.includes(detalle.id)"
            placeholder="Seleccione uno" />
        </td>
      </tr>

      <tr>
        <td class="px-2 caption"></td>
        <td :colspan="esTipoGastos ? 10 : 9" class="px-2 text-right">Total a Desembolsar</td>
        <td class="px-2 text-right">
          {{ formatearValorAMoneda(totalADesembolsar) }}
        </td>
        <td class="px-2 text-right">
          <small>Transferencia</small> {{ formatearValorAMoneda(totalADesembolsarTransferencia) }} <br />
          <small>Cheque</small> {{ formatearValorAMoneda(totalADesembolsarCheque) }} <br />
          <small>Efectivo</small> {{ formatearValorAMoneda(totalADesembolsarEfectivo) }}
        </td>
        <td class="px-2"></td>
      </tr>

      <tr>
        <td></td>
        <td :colspan="esTipoGastos ? 10 : 9" class="px-2 text-right">Total sin Desembolsar</td>
        <td class="px-2 text-right">
          {{ formatearValorAMoneda(totalSinDembolsar) }}
        </td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td></td>
        <td :colspan="esTipoGastos ? 10 : 9" class="px-2 text-right">Total</td>
        <td class="px-2 text-right">
          {{ formatearValorAMoneda(total) }}
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { formatearValorAMoneda, TIPOS_DESEMBOLSOS, TIPOS_SOLICITUD } from '../utils';

export default {
  name: 'TablaDetalleDesembolso',
  props: {
    detallesSolicitud: {
      type: Array,
      default: () => [],
    },
    tipo: {
      type: String,
      validator: (value) => {
        return [TIPOS_SOLICITUD.RECURSOS, TIPOS_SOLICITUD.GASTOS, 'todos'].includes(value);
      },
    },
    modalMostrado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tipoDesembolsoParaTodos: null,
      tipoDesembolsos: Object.values(TIPOS_DESEMBOLSOS).map((tipo) => ({
        text: tipo,
        value: tipo,
      })),
      detallesSolicitudesSeleccionados: [],
    };
  },
  watch: {
    modalMostrado(value) {
      if (!value) {
        this.tipoDesembolsoParaTodos = null;
        this.detallesSolicitudesSeleccionados = [];
      }
    },
    detallesSolicitudesSeleccionados(value) {
      this.detallesSolicitud.forEach((detalle) => {
        if (!value.includes(detalle.id)) {
          detalle.tipo_desembolso = null;
        }
      });

      this.$emit('actualizarDetallesSolicitudesSeleccionadas', value);
    },
  },
  computed: {
    esTipoGastos() {
      return this.tipo === TIPOS_SOLICITUD.GASTOS;
    },
    checkboxEsIndeterminado() {
      return (
        this.detallesSolicitudesSeleccionados.length < this.detallesSolicitud.length &&
        this.detallesSolicitudesSeleccionados.length != 0
      );
    },
    estanMarcadosTodos() {
      return this.detallesSolicitudesSeleccionados.length == this.detallesSolicitud.length;
    },
    total() {
      return this.detallesSolicitud.reduce((a, b) => parseFloat(a) + parseFloat(b.importe), 0);
    },
    totalADesembolsar() {
      return this.detallesSolicitud.reduce((a, b) => {
        if (this.detallesSolicitudesSeleccionados.includes(b.id)) {
          return parseFloat(a) + parseFloat(b.importe);
        }

        return parseFloat(a);
      }, 0);
    },
    totalSinDembolsar() {
      return this.total - this.totalADesembolsar;
    },
    totalADesembolsarCheque() {
      return this.detallesSolicitud.reduce((a, b) => {
        if (this.detallesSolicitudesSeleccionados.includes(b.id) && b.tipo_desembolso === TIPOS_DESEMBOLSOS.CHEQUE) {
          return parseFloat(a) + parseFloat(b.importe);
        }

        return parseFloat(a);
      }, 0);
    },
    totalADesembolsarTransferencia() {
      return this.detallesSolicitud.reduce((a, b) => {
        if (
          this.detallesSolicitudesSeleccionados.includes(b.id) &&
          b.tipo_desembolso === TIPOS_DESEMBOLSOS.TRANSFERENCIA
        ) {
          return parseFloat(a) + parseFloat(b.importe);
        }

        return parseFloat(a);
      }, 0);
    },
    totalADesembolsarEfectivo() {
      return this.detallesSolicitud.reduce((a, b) => {
        if (this.detallesSolicitudesSeleccionados.includes(b.id) && b.tipo_desembolso === TIPOS_DESEMBOLSOS.EFECTIVO) {
          return parseFloat(a) + parseFloat(b.importe);
        }

        return parseFloat(a);
      }, 0);
    },
  },
  methods: {
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
    cambiarTipoDesembolsoParaTodos() {
      this.detallesSolicitud.forEach((detalle) => {
        if (this.detallesSolicitudesSeleccionados.includes(detalle.id)) {
          detalle.tipo_desembolso = this.tipoDesembolsoParaTodos;
        }
      });
    },
    marcarDesmarcarTodos() {
      if (this.estanMarcadosTodos) {
        this.detallesSolicitudesSeleccionados = [];
      } else {
        this.detallesSolicitudesSeleccionados = this.detallesSolicitud.map((detalle) => detalle.id);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>